export default __webpack_public_path__ + "static/media/test.85e5305d.mp4";